import Button from '@/components/base/button/button';
import Modal from '@/components/base/modal/modal';
import { Link } from '@/navigation';
import { Redirect, getRedirectPath } from '@/utils/redirects';
import { useLocale, useTranslations } from 'next-intl';
import { type ComponentProps, useTransition } from 'react';

interface Props
  extends Required<Pick<ComponentProps<typeof Modal>, 'isOpen' | 'setIsOpen'>> {
  onConfirm: () => void;
  isPending?: boolean;
  setRequiredConsents: () => void;
}

const RequiredConsentsModal = ({
  onConfirm,
  setIsOpen,
  isOpen,
  isPending,
  setRequiredConsents,
}: Props) => {
  const t = useTranslations('login.register.required_consents_modal');
  const tc = useTranslations('common');
  const [isTransitionPending, startTransition] = useTransition();

  const handleConfirm = () => {
    startTransition(() => {
      setRequiredConsents();
      onConfirm();
    });
  };

  const locale = useLocale();
  const tcLink = locale ? getRedirectPath(Redirect.REGULATIONS, locale) : '#';

  return (
    <Modal title={t('title')} isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="flex flex-col p-inner">
        <div className="pb-inner">
          {t.rich('info', {
            link: (chunks) => (
              <Link href={tcLink}>
                <span className="underline">{chunks}</span>
              </Link>
            ),
          })}
        </div>
        <div className="flex gap-xs s:self-end">
          <Button variant="secondary" onClick={() => setIsOpen(false)}>
            {tc('refuse')}
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            testId="accept_continue_button"
            isLoading={isPending || isTransitionPending}
          >
            {t('btn_accept_continue')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RequiredConsentsModal;
